import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />

      <main className="mx-auto max-w-4xl px-6 py-20">
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.35em] text-[#D4AF37]">
          Legal
        </p>

        <h1 className="mb-4 text-4xl font-black md:text-5xl">
          Terms of Service
        </h1>

        <p className="mb-12 text-zinc-400">
          Last updated: 5/3/2026
        </p>

        <p className="mb-8 text-zinc-200">
          By using Capital Access Hub, you agree to the following terms.
        </p>

        <section className="space-y-8 text-zinc-200">
          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">Not a Lender</h2>
            <p>
              Capital Access Hub is not a lender. We connect businesses with funding
              partners. We do not make credit decisions or guarantee funding approval.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">No Guarantee</h2>
            <p>
              Submission of your information does not guarantee approval, funding
              amount, rates, or timelines. All decisions are made by third-party
              funding providers.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">
              Information Accuracy
            </h2>
            <p>
              You agree to provide accurate and complete information. Providing false
              or misleading information may affect your eligibility for funding.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">
              Consent to Contact
            </h2>
            <p>
              By submitting your information, you agree to be contacted by Capital
              Access Hub and its partners regarding funding options.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">Compensation</h2>
            <p>
              Capital Access Hub may receive compensation from funding partners for
              referrals.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">
              Limitation of Liability
            </h2>
            <p>
              Capital Access Hub is not responsible for any decisions, terms, or
              agreements made between you and any funding partner.
            </p>
          </div>

          <div>
            <h2 className="mb-2 text-2xl font-bold text-white">Contact</h2>
            <p>
              If you have questions, contact us at:{" "}
              <a
                href="mailto:funding@meltedportstudios.com"
                className="text-[#D4AF37] hover:underline"
              >
                funding@meltedportstudios.com
              </a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
